function defaultHandler(res) {
  const error = new Error("ResponseError");
  error.name = "ResponseError";
  error.response = res.clone();

  if (!res.ok) {
    throw error;
  }

  return res.json()
    .then((res) => {
      if (!res.ok) {
        throw error;
      }

      return res;
    });
}

function networkErrorHandler(err) {
  const error = new Error("Network error");
  error.name = "NetworkError";
  error.parentError = err;

  throw error;
}

function defaultErrorHandler(err) {
  throw err;
}

export function store(optionsArg, retry) {
  const options = Object.assign({}, optionsArg);

  ["disk", "file"].forEach((param) => {
    if (!options[param]) {
      throw new Error(`No '${param}' parameter`);
    }
  });

  const url = retry
    ? window.appConfig.paths.imagesStoreFallback
    : window.appConfig.paths.imagesStore;

  return fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
    },
    body: JSON.stringify({
      disk: options.disk,
      file: options.file,
      file_name: options.fileName,
      file_type: options.fileType,
      crop: options.crop,
      blur: options.blur,
    }),
  })
    .catch(networkErrorHandler)
    .then(defaultHandler)
    .catch((error) => {
      return !retry
        ? store(optionsArg, true)
        : defaultErrorHandler(error);
    });
}

export default {
  store: store,
};
